const LinkIcon = ({color = 'currentColor', width = 16, height = 16}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M2 6.5V2H6.5M2 2L7.5 7.5M9.73333 2C11.2267 2 11.9733 2 12.544 2.29067C13.0457 2.54633 13.4537 2.95426 13.7093 3.456C14 4.02667 14 4.77333 14 6.26667V9.73333C14 11.2267 14 11.9733 13.7093 12.544C13.4537 13.0457 13.0457 13.4537 12.544 13.7093C11.9733 14 11.2267 14 9.73333 14H6.26667C4.77333 14 4.02667 14 3.456 13.7093C2.95426 13.4537 2.54633 13.0457 2.29067 12.544C2 11.9733 2 11.2267 2 9.73333V9"
            stroke={color}
            strokeWidth="0.666667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default LinkIcon;
